import React, { useState } from "react";
import cx from "clsx";
import { getUserPaymentSystem } from "../../../../../../../utilities/localStorage";
import { Button } from "../../../../../../../shared/Button/Button";
import styles from "../scss/AdditionalClinicSurges.module.scss";
import { Table } from "../../../../../../../shared/Table/Table";
import { DeleteIcon } from "../../../../../../../assets/Icons/DeleteIcon";
import { EditIcon } from "../../../../../../../assets/Icons/EditIcon";
import { InfoIcon } from "../../../../../../../assets/Icons/InfoIcon";
import EditClinicAdditionalSurgesModal from "./EditClinicAdditionalSurgesModal";
import { useAdditionalClinicSurges } from "../hooks/useAdditionalClinicSurges";
import EditClinicAdditionalSurgesDelete from "./EditClinicAdditionalSurgesDelete";
import ClearentSurchargeEnrollmentModal from "../ClearentSurchargeEnrollmentModal.js";
import {
  applicationLevelOptions,
  exclusionsOptions,
  rulesOptions,
  taxTypeOptions,
} from "../AdditionalClinicSurgesModal.utils";

const EditClinicAdditionalSurges = ({ clinicId }) => {
  const [modal, setModal] = useState({ show: false, data: null });
  const [deleteModal, setDeleteModal] = useState({ show: false, id: null });
  const [showClearentModal, setShowClearentModal] = useState(false);

  const { data } = useAdditionalClinicSurges(clinicId);
  const isClearent = getUserPaymentSystem() === "clearent";

  const tableData = data?.map((item) => {
    const applicationLevel = applicationLevelOptions.find(
      (option) => option.value === item.level,
    );
    const taxType = taxTypeOptions.find(
      (option) => option.value === item.tax_type,
    );
    const cascading = item.cascading ? "Yes" : "No";

    const rules = rulesOptions.find((option) => option.value === item.type);

    const exclusions = exclusionsOptions
      .filter((option) => item.exclusions_array.includes(option.value))
      .map((option) => option.label);

    return {
      name: item.label,
      percentage: item.percentage,
      applicationLevel: applicationLevel.label,
      taxType: taxType.label,
      cascading,
      exclusions: exclusions.join(", ") || "None",
      rules: rules.label,
      action: (
        <div className={styles.actionCol}>
          <button
            className={cx(styles.actionBtn, styles.edit)}
            onClick={() => setModal({ show: true, data: item })}
          >
            {" "}
            <EditIcon width="15px" />
          </button>
          <button
            className={cx(styles.actionBtn, styles.delete)}
            onClick={() => setDeleteModal({ show: true, id: item.id })}
          >
            <DeleteIcon width="15px" />
          </button>
        </div>
      ),
    };
  });

  return (
    <>
      <div className={styles.container}>
        <div className={styles.titleRow}>
          <Button
            variant="text"
            rightAdornment={<div className={styles.plusIcon}>+</div>}
            onClick={() => setModal({ show: true, data: null })}
            className={styles.additionalSurchargesBtn}
          >
            Additional Clinic Surcharges
          </Button>
          {isClearent && (
            <button
              type="button"
              className={styles.infoBtn}
              onClick={() => setShowClearentModal(true)}
            >
              <InfoIcon width="16px" />
            </button>
          )}
        </div>
        {data?.length > 0 && (
          <Table
            className={styles.surchargesTable}
            cols={[
              { data: "Name", accessor: "name" },
              { data: "Percentage", accessor: "percentage" },
              { data: "Application Level", accessor: "applicationLevel" },
              { data: "Tax Type", accessor: "taxType" },
              { data: "Cascading", accessor: "cascading" },
              { data: "Rules", accessor: "rules" },
              { data: "Exclusions", accessor: "exclusions" },
              { data: "Action", accessor: "action" },
            ]}
            data={tableData}
          />
        )}
      </div>
      {modal.show && (
        <EditClinicAdditionalSurgesModal
          clinicId={clinicId}
          modal={modal}
          setModal={setModal}
          isClearent={isClearent}
        />
      )}
      {deleteModal.show && (
        <EditClinicAdditionalSurgesDelete
          clinicId={clinicId}
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
        />
      )}
      {showClearentModal && (
        <ClearentSurchargeEnrollmentModal
          onBack={() => setShowClearentModal(false)}
        />
      )}
    </>
  );
};

export default EditClinicAdditionalSurges;
